<template>
    <div class="flex-sub wrapper flex flex-direction padding">
        <div class="flex align-center justify-between">
            <div class="text-df">党员示范岗</div>
            <el-button class="btn small" plain @click="$router.go(-1)">返回</el-button>
        </div>
        <div class="flex-sub bg-white radius margin-top-sm padding-xl ">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form  w-70" labelWidth="auto">
                <el-form-item ref="id" label="姓名" prop="id">
                    <el-select
                        v-model="ruleForm.id"
                        class="w-all"
                        placeholder="请选择" :disabled="readonly" filterable @change="memberChange">
                        <el-option
                            v-for="(item) in members"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item ref="duty" label="职务" prop="duty">
                    <el-input v-model="ruleForm.duty" placeholder="请输入" :disabled="readonly">
                    </el-input>
                </el-form-item>
                <el-form-item ref="img" label="照片" prop="img">
                   <div class="flex align-end">
                       <upload-avatar-file :file="ruleForm.img" :disabled="readonly" @uploadAvatar="uploadAvatar"></upload-avatar-file>
                       <div class="text-red text-xs margin-left" v-if="!readonly">上传照片(格式为png或jpg且2M以内，推荐尺寸：345*450px)</div>
                   </div>
                </el-form-item>

            </el-form>
            <div class="flex align-center justify-end margin-top w-70" v-if="!readonly">
                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm')">保存
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

import {TOAST, toast} from "@/utils/utils";
import UploadAvatarFile from "@/views/web/components/UploadAvatarFile";
import {addDemonstrate, getStationDetail, getStationMembers} from "@/api";

export default {
    name: "station-add",
    components: {UploadAvatarFile},
    data() {
        return {
            mid: 0,
            ruleForm: {
                img: '',//头像
                id: '',
                party_branch: '',
                duty: '',
            },
            rules: {
                id: [
                    {required: true, message: '请选择人员', trigger: 'change'},
                ],
                img: [
                    {required: true, message: '请上传照片', trigger: 'change'},
                ],
                party_branch: [
                    {required: true, message: '请输入所在党支部', trigger: 'change'},
                ],
                duty: [
                    {required: true, message: '请输入职务', trigger: 'change'},
                ]
            },
            loading: false,
            readonly:false,
            members:[]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.mid = Number( this.$route.params.id || 0)
        this.$emit('setIndex', [4,1])
        this.init()
        if (this.mid) this.getUserDetail()
    },
    methods: {
        async init() {
            let _data = await getStationMembers()
            this.members = _data.data
        },
        async getUserDetail() {
            let _data = await getStationDetail(1,this.mid)
            this.ruleForm.img = _data.data.img
            this.ruleForm.id = _data.data.id
            this.ruleForm.duty = _data.data.duty
            this.ruleForm.party_branch = _data.data.party_branch
        },
        memberChange(e) {
            if (e) {
                let find = this.members.find(f=>{return f.id === e});
                this.ruleForm.img = find.img
                this.ruleForm.duty = find.duty
                this.ruleForm.party_branch = find.party_branch
            }else{
                this.ruleForm.img = ''
                this.ruleForm.duty = ''
                this.ruleForm.party_branch = ''
            }
        },
        uploadAvatar(data){
            this.ruleForm.img = data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem();
                }
            });
        },
        async addItem() {
            this.loading = true
            let _data = await addDemonstrate(this.ruleForm.id, this.ruleForm.party_branch, this.ruleForm.duty, this.ruleForm.img)
            this.loading = false
            if (_data.status === 200) {
                toast('保存成功', TOAST.success)
                this.$router.go(-1)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
    },
    filters: {

    }
}
</script>

<style lang="scss" scoped>
.wrapper {

}
</style>